// Scroll-restore on route change. Mount once inside <BrowserRouter>.
// Each new pathname → scroll to top instantly. Hash links preserved (#id → jump to that element).
// Back/forward buttons restore the previous scroll position automatically (browser default).
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    // POP = browser back/forward → let browser handle scroll restoration.
    if (navType === "POP") return;
    // Hash link (#section) → scroll to that element after a tick.
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 0);
        return;
      }
    }
    // Normal navigation → instant top.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, navType]);

  return null;
}
